import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["row"];

  connect() {
    console.log("Targets: => ", this.rowTargets);
    console.log("Targets Count: =>", this.rowTargets.length);
  }

  handleRowClick(event) {
    const row = event.currentTarget;

    // Prevent clicks on interactive elements (e.g., links, buttons) inside the row
    if (this.isInteractiveElement(event.target)) {
      return;
    }

    const href = row.dataset.href;
    if(href) {
      window.location.href = href;
    }
  }

  // Check if the clicked element is interactive
  isInteractiveElement(target) {
    const tagName = target.tagName.toLowerCase();
    return (
      tagName === "a" ||
      tagName === "button" ||
      tagName === "input" ||
      target.closest("a, button, input") !== null
    );
  }

  disconnect() {}
}
